export type WarrantyJourneyStage = 'image' | 'phone' | 'ready' | 'processing' | 'retry_image' | 'complete'

export function isRetryableVerificationStatus(status: string) {
  return status === 'needs_input' || status === 'no_match'
}

export function resolveWarrantyJourneyStage(input: {
  hasFile: boolean
  hasPhone: boolean
  busy: boolean
  retryPending: boolean
  completed: boolean
}): WarrantyJourneyStage {
  if (input.completed) return 'complete'
  if (input.busy) return 'processing'
  if (input.retryPending && !input.hasFile) return 'retry_image'
  if (!input.hasFile) return 'image'
  if (!input.hasPhone) return 'phone'
  return 'ready'
}

export const warrantyJourneyCopy: Record<WarrantyJourneyStage, string> = {
  image: 'Bước 1/3 · Gửi ảnh đơn hàng',
  phone: 'Bước 2/3 · Nhập số điện thoại',
  ready: 'Bước 3/3 · Sẵn sàng đăng ký',
  processing: 'Đang kiểm tra thông tin đơn hàng',
  retry_image: 'Cần ảnh khác để tiếp tục phiên',
  complete: 'Đã hoàn tất phiên đăng ký',
}

export function warrantyJourneyStep(stage: WarrantyJourneyStage) {
  if (stage === 'image' || stage === 'retry_image') return 1
  if (stage === 'phone') return 2
  if (stage === 'complete') return 4
  return 3
}
